import React, { useEffect, useState } from "react";
import NotFoundImage from "../assets/cms/not-found.jpg";
import { Link, useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
// import Link from "antd/es/typography/Link";

const NotFound = () => {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <h1 style={{ marginBottom: "20px" }}>This route doesn't exist</h1>
      <img style={{ width: "80%" }} src={NotFoundImage} />
      <h1 style={{ marginTop: "20px" }}>
        Take me <Link to="/dashboard">Home</Link>
      </h1>
    </div>
  );
};

export default NotFound;
